import { defineComponent as _defineComponent } from 'vue'
import AddMoneyModal from 'ah-wallets/src/components/AddMoneyModal.vue';
import CreateTradeModal from '../../modals/CreateTradeModal.vue';
import { AuthorityType } from 'ah-api-gateways';
import { computed, reactive } from 'vue';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';
import { useAhTradesState } from '../../..';
import { VButton } from 'ah-common-lib/src/common/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddOrConvertCurrencyButtons',
  setup(__props) {

const onBehalfOfClient = useOnBehalfOf();

const tradeState = useAhTradesState();

const state = reactive<{
  allowedSellCurrencies: string[];
  currencies: string[];
}>({
  allowedSellCurrencies: [],
  currencies: ['GBP', 'EUR', 'USD'],
});

const canSeeFundingDetails = computed(
  () => onBehalfOfClient.value || tradeState.store.useAuthStore().hasAuthorities(AuthorityType.VIEW_FUNDING_DETAILS)
);

const openTradeAllowed = computed(
  () => onBehalfOfClient.value || tradeState.store.useAuthStore().hasAuthorities(AuthorityType.OPEN_TRADE)
);

const requestPricesAllowed = computed(
  () => onBehalfOfClient.value || tradeState.store.useAuthStore().hasAuthorities(AuthorityType.REQUEST_PRICES)
);

function loadTradeableCurrencies() {
  tradeState.store
    .useSettingsStore()
    .loadTradeableCurrencies()
    .then((currencies) => {
      state.allowedSellCurrencies = currencies
        .map((currencyObj) => currencyObj.currency)
        .filter((currencyObj) => {
          return !state.currencies.includes(currencyObj);
        });
    });
}

loadTradeableCurrencies();

return { __sfc: true,onBehalfOfClient, tradeState, state, canSeeFundingDetails, openTradeAllowed, requestPricesAllowed, loadTradeableCurrencies, AddMoneyModal, CreateTradeModal, VButton }
}

})